import { BusinessUnit } from "../models/business-unit";
import { httpGet } from "./http-client";

const apiUrl = '/api/businessunits';

export const getBusinessUnits = () => httpGet<BusinessUnit[]>(apiUrl);
